export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig(event);
    const BASE_PROGETTO = config.public.base_progetto;

    return {
        provide: {
            localStorage: {
                getItem(item) {
                    if (process.client) {
                        return localStorage.getItem(item + BASE_PROGETTO);
                    } else {
                        return undefined;
                    }
                },

                setItem(item, value) {
                    if (process.client) {
                        return localStorage.setItem(item + BASE_PROGETTO, value);
                    }
                },

                removeItem(item) {
                    if (process.client) {
                        return localStorage.removeItem(item + BASE_PROGETTO);
                    }
                }
            }
        }
    };
});
